__turbopack_context__.v({
  "clearButton": "Search-module__cO60qa__clearButton",
  "container": "Search-module__cO60qa__container",
});
